import { FC } from "react";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import { AIIcon } from "@/assets/icons/app-related/AIIcon";

export const ViewKubernetesAiRecommendationsButton: FC = () => {
  return (
    <Button
      component={Link}
      sx={buttonStyles}
      variant="contained"
      startIcon={<AIIcon color="white" />}
      to="/recommendations/ai-kubernetes-recommendations"
    >
      View Recommendations
    </Button>
  );
};

const buttonStyles = {
  borderRadius: 21,
  background: "linear-gradient(140.15deg, #1443EA 0%, #7334F1 89.74%)",
};
